import React from 'react';
import PageDirectory from '../components/PageDirectory';
import { FAQ_PAGES } from '../config/faqPages';

// Directory of the FAQ pages, split out of Home. The list and the card markup
// live elsewhere; this file only names the page.
function Faqs() {
  return (
    <PageDirectory
      title="Brookline Notepad FAQs"
      pages={FAQ_PAGES}
      emptyText="No FAQ pages are available to you yet."
      disclaimer={
        <p>
          Each FAQ is published by its own petitioner or committee and carries that
          page's own disclaimer.
        </p>
      }
    />
  );
}

export default Faqs;
